import PropTypes from 'prop-types';
import React from 'react';
import imagesUtils from '../../../../variables/images';

const TemplateCard = ({ description, guid, image, onSelect, selected, title }) => {
  function handleSelect() {
    onSelect(guid);
  }

  const backgroundImage = `url(${image || imagesUtils.getImage('noItem')})`;

  return (
    <button aria-pressed={selected} className={`template-card template-card--${selected ? 'selected' : 'default'}`} onClick={handleSelect} type="button">
      <div className="template-card__image">
        <div className="template-card__description">{description}</div>
        <div className="template-card__background-image" style={{ backgroundImage }}></div>
      </div>
      <div className="template-card__info">
        <div className="template-card__title">{title}</div>
        <span aria-hidden="true" className="template-card__radio" />
      </div>
    </button>
  );
};

TemplateCard.propTypes = {
  description: PropTypes.string,
  guid: PropTypes.string,
  image: PropTypes.string,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
  title: PropTypes.string,
};

export default TemplateCard;
